import { getBackendUrl } from "../../../../utils/env";

// Normaliza la base para no depender de si getBackendUrl() termina en "/"
const baseUrl = () => getBackendUrl().replace(/\/+$/, "");

const baseKermesUrl = () => `${baseUrl()}/api/admin/Kermes`;

const productsUrl = () => `${baseKermesUrl()}/products.php`;
const createOrderUrl = () => `${baseKermesUrl()}/create_order.php`;
const ordersUrl = () => `${baseKermesUrl()}/orders.php`;
const cancelOrderUrl = () => `${baseKermesUrl()}/cancel_order.php`;
const inventoryUrl = () => `${baseKermesUrl()}/inventory.php`;
const addInventoryUrl = () => `${baseKermesUrl()}/add.php`;
const dashboardUrl = () => `${baseKermesUrl()}/dashboard.php`;

// Obtener productos
export const getKermesProducts = async () => {
    const response = await fetch(productsUrl());

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(
            data.message || "No se pudieron obtener los productos."
        );
    }

    return data;
};

// Registrar venta
export const createKermesOrder = async (orderData) => {
    const response = await fetch(createOrderUrl(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(
            data.message || "No se pudo registrar la venta."
        );
    }

    return data;
};

// Obtener historial de ventas
export const getKermesOrders = async () => {
    const response = await fetch(ordersUrl());

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(
            data.message || "No se pudieron obtener las ventas."
        );
    }

    return data;
};

// Cancelar venta
export const cancelKermesOrder = async (orderId, userId = null) => {
    const response = await fetch(cancelOrderUrl(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            order_id: orderId,
            user_id: userId,
        }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(
            data.message || "No se pudo cancelar la venta."
        );
    }

    return data;
};

// Obtener inventario
export const getKermesInventory = async () => {
    const response = await fetch(inventoryUrl());

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(
            data.message || "No se pudo obtener el inventario."
        );
    }

    return data;
};

// Agregar inventario
export const addKermesInventory = async (data) => {

    const response = await fetch(addInventoryUrl(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    return await response.json();
};
export const createKermesProduct = async (data) => {

    const response = await fetch(
        `${baseKermesUrl()}/create-product.php`,
        {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json'
            },

            body: JSON.stringify(data)
        }
    );

    return await response.json();
};

// Obtener corte de caja / dashboard
export const getKermesDashboard = async () => {
    const response = await fetch(dashboardUrl());

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(
            data.message || "No se pudo obtener el corte de caja."
        );
    }

    return data;
};


// Obtener pedidos anticipados
const createPreorderUrl = () => `${baseKermesUrl()}/create_preorder.php`;
const preordersUrl = () => `${baseKermesUrl()}/preorders.php`;
const deliverPreorderUrl = () => `${baseKermesUrl()}/deliver_preorder.php`;
const cancelPreorderUrl = () => `${baseKermesUrl()}/cancel_preorder.php`;


const parseResponse = async (response, fallbackMessage) => {
  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(fallbackMessage);
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.message || fallbackMessage);
  }
  return data;
};

export const createKermesPreorder = async (orderData) => {
  const response = await fetch(createPreorderUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(orderData),
  });
  return parseResponse(response, "No se pudo registrar el pedido.");
};

export const getKermesPreorders = async () => {
  const response = await fetch(preordersUrl());
  return parseResponse(response, "No se pudieron cargar los pedidos.");
};

export const deliverKermesPreorder = async (preorderId) => {
  const response = await fetch(deliverPreorderUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ preorder_id: preorderId }),
  });
  return parseResponse(response, "No se pudo marcar el pedido como entregado.");
};

export const cancelKermesPreorder = async (preorderId, userId = null) => {
  const response = await fetch(cancelPreorderUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ preorder_id: preorderId, user_id: userId }),
  });
  return parseResponse(response, "No se pudo cancelar el pedido.");
};


// Obtener corte de caja / dashboard
const  saveCashClosingUrl = () => `${baseKermesUrl()}/saveCashClosing.php`;
const getCashClosingUrl = () => `${baseKermesUrl()}/getCashClosing.php`;

export const saveKermesCashClosing = async (payload) => {

    const response = await fetch(
        saveCashClosingUrl(),
        {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',

                Authorization:
                    `Bearer ${localStorage.getItem('token')}`
            },

            body: JSON.stringify(payload)
        }
    );


    const data = await response.json();


    if (!response.ok || !data.success) {

        throw new Error(
            data.message ||
            'No se pudo guardar el corte.'
        );

    }


    return data;
};


export const getKermesCashClosing = async () => {

    const response = await fetch(
        getCashClosingUrl(),
        {
            headers: {

                Authorization:
                    `Bearer ${localStorage.getItem('token')}`

            }
        }
    );


    const data = await response.json();


    if (!response.ok || !data.success) {

        throw new Error(
            data.message ||
            'No se pudo consultar el corte.'
        );

    }


    return data;
};
